import React, { Component } from "react"
import styled from "styled-components"
import { HashLink as Link } from "react-router-hash-link-offset"
import { Icon } from "semantic-ui-react"
import Media from "react-media"

import logo from "../library/images/logo-image-file.png"
import msrb from "../library/images/Maneater_ESRB.jpg"

const currentDate = new Date()
const currentYear = currentDate.getFullYear()

export default class Footer extends Component {
  render() {
    return (
      <FooterWrapper>
        <SocialWrapper>
          <a
            href="https://www.facebook.com/tripwireinteractive"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="facebook" size="big" className="social-icon" />
          </a>
          <a
            href="https://www.youtube.com/user/tripwireinteractive"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="youtube" size="big" className="social-icon" />
          </a>
          <a
            href="https://twitter.com/TripwireInt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="twitter" size="big" className="social-icon" />
          </a>
          <a
            href="https://www.instagram.com/tripwireinteractive/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="instagram" size="big" className="social-icon" />
          </a>
          <a
            href="https://www.twitch.tv/tripwireinteractive"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="twitch" size="big" className="social-icon" />
          </a>
        </SocialWrapper>
        <NewsletterWrapper>
          <Link to="/signup/#top">
            <Icon name="mail" size="big" className="social-icon" />
          </Link>
          <Link to="/signup/#top">
            <div>
              <h4>Sign up for our newsletter!</h4>
            </div>
          </Link>
        </NewsletterWrapper>
        <Media query="(max-width: 1200px)">
          {(matches) =>
            matches ? (
              <LinkWrapper>
                <div>
                  <Link to="/#top">
                    <img src={logo} alt="TripWire Company Logo" />
                  </Link>
                </div>
                <div>
                  <Link to="/company/#top">
                    <h4>ABOUT TRIPWIRE</h4>
                  </Link>
                </div>
                <div>
                  <Link to="/company/#policies">
                    <h4>POLICIES</h4>
                  </Link>
                </div>
                <div>
                  <a
                    href="https://support.tripwireinteractive.com/en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h4>SUPPORT</h4>
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.designbyhumans.com/shop/TripwireInteractive/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h4>SHOP</h4>
                  </a>
                </div>
                <div>
                  <Link to="/company/#contact">
                    <h4>CONTACT</h4>
                  </Link>
                </div>
                <div>
                  <h4 style={{ margin: "15px 0" }}>
                    {`© ${currentYear} Tripwire Interactive - All Rights Reserved`}
                  </h4>
                </div>
                <div>
                  <a
                    href="https://www.esrb.org/ratings/ratings_guide.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={msrb} alt="MSRB Rating: Mature" />
                  </a>
                  {/* <img
                    src="https://imgix.cosmicjs.com/2a1d0eb0-9fe4-11ec-a634-2f1716dd45af-Inc.-5000-Color-Medallion-Logo-1.png"
                    alt="Inc. 5000"
                  /> */}
                </div>
              </LinkWrapper>
            ) : (
              <LinkWrapper>
                <div>
                  <Link to="/#top" scrollOffset={-116}>
                    <img src={logo} alt="TripWire Company Logo" />
                  </Link>
                </div>
                <div>
                  <Link to="/company/#top" scrollOffset={-116}>
                    <h4>ABOUT TRIPWIRE</h4>
                  </Link>
                </div>
                <div>
                  <Link to="/company/#policies" scrollOffset={-116}>
                    <h4>POLICIES</h4>
                  </Link>
                </div>
                <div>
                  <a
                    href="https://support.tripwireinteractive.com/en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h4>SUPPORT</h4>
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.designbyhumans.com/shop/TripwireInteractive/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h4>SHOP</h4>
                  </a>
                </div>
                <div>
                  <Link to="/company/#contact" scrollOffset={-116}>
                    <h4>CONTACT</h4>
                  </Link>
                </div>
                <div>
                  <h4 style={{ margin: "15px 0" }}>
                    {`© ${currentYear} Tripwire Interactive - All Rights Reserved`}
                  </h4>
                </div>
                <div>
                  <a
                    href="https://www.esrb.org/ratings/ratings_guide.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={msrb} alt="MSRB Rating: Mature" />
                  </a>
                  {/* <img
                    src="https://imgix.cosmicjs.com/2a1d0eb0-9fe4-11ec-a634-2f1716dd45af-Inc.-5000-Color-Medallion-Logo-1.png"
                    alt="Inc. 5000"
                  /> */}
                </div>
              </LinkWrapper>
            )
          }
        </Media>
      </FooterWrapper>
    )
  }
}

const FooterWrapper = styled.div`
  background: black;
  color: white;
  padding: 2%;
  margin: 0;
  border-top: solid;
  border-width: 2px;
  border-color: #fde704;
  text-align: center;

  img {
    height: 100px;
    padding: 10px 5px;
  }

  h4 {
    margin: 10px 0;
    padding: 9px;
  }

  @media (max-width: 800px) {
    padding: 3.5% 2%;
  }

  @media (max-width: 650px) {
    padding: 5% 2%;
  }
`

const SocialWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 5px 0;

  a {
    margin: 2vw;
  }

  @media (max-width: 650px) {
    margin: 10px 0;
    justify-content: space-around;
  }
`

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;

  a:hover {
    text-decoration: underline;
  }
`

const NewsletterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
`



// WEBPACK FOOTER //
// ./src/components/Footer.js